if (!customElements.get('product-form-custom')) {
  // Constants
  const ELEMENT_NAME = 'product-form-custom';
  const SELECTOR_FORM = 'form';
  const SELECTOR_ID_INPUT = '[name=id]';
  const SELECTOR_SUBMIT_BUTTON = '[type="submit"]';
  const SELECTOR_COLOR_INPUT = '[data-value-type="color"]';
  const SELECTOR_SIZE_INPUT = '[data-value-type="size"]';
  const SELECTOR_COLOR_LABEL = '[data-color-label]';
  const SELECTOR_VARIANT_SELECTS = 'variant-selects';
  const SELECTOR_FORM_BTN = '[data-form-btn]';
  const SELECTOR_FORM_BTN_SUBMIT = '[data-form-btn="submit"]';
  const SELECTOR_VARIANT_LABEL = '[data-form-variant-label]';
  const SELECTOR_VPC_CARD_INPUT = 'input[type="radio"]';
  const SELECTOR_CART_NOTIFICATION = 'cart-notification';
  const SELECTOR_CART_DRAWER = 'cart-drawer';
  const SELECTOR_QUICK_ADD_MODAL = 'quick-add-modal';
  const SELECTOR_LOADING_SPINNER = '.loading__spinner';
  const SELECTOR_ERROR_WRAPPER = '.product-form__error-message-wrapper';
  const SELECTOR_ERROR_MESSAGE = '.product-form__error-message';
  const SELECTOR_SOLD_OUT_MESSAGE = '.sold-out-message';
  const SELECTOR_SPAN = 'span';

  const ATTR_ARIA_HASPOPUP = 'aria-haspopup';
  const ATTR_ARIA_DISABLED = 'aria-disabled';
  const ATTR_DATA_VALUE = 'data-value';
  const ATTR_DATA_VALUE_TYPE = 'data-value-type';
  const ATTR_DATA_COLOR_VALUE = 'data-color-value';
  const ATTR_DATA_PRICE = 'data-price';
  const ATTR_DATA_SHOW_PRICE_IN_BUTTON = 'data-show-price-in-button';
  const ATTR_DATA_AUTO_DISCOUNT = 'data-auto-discount';
  const ATTR_DATA_ORIGINAL_PRICE = 'data-original-price';
  const ATTR_DISABLED = 'disabled';
  const ATTR_HIDDEN = 'hidden';
  const ATTR_DATA_HIDE_ERRORS = 'data-hideErrors';

  const CLASS_LOADING = 'loading';
  const CLASS_HIDDEN = 'hidden';
  const CLASS_DISABLED = 'disabled';
  const CLASS_SWATCH_ACTIVE = 'swatch-active';
  const CLASS_IS_EMPTY = 'is-empty';
  const CLASS_BUTTON_PRICE = 'button-price';

  const CHANGE_TYPES = {
    FORM: 'formChange',
    COLOR: 'colorChange',
    SIZE: 'sizeChange',
    CUSTOM_DATA: 'customDataChange',
    MOCKUP_SET: 'mockupSet',
    ORIGINAL_IMAGE_SET: 'originalImageSet',
    UNKNOWN: 'unknown'
  };

  // Event names
  const EVENT_CHANGE = 'productFormCustom:change';
  const EVENT_COLOR_CHANGE = 'productFormCustom:colorChange';
  const EVENT_SIZE_CHANGE = 'productFormCustom:sizeChange';

  // Custom data keys
  const CUSTOM_DATA_KEY_MOCKUP = '_Mockup';
  const CUSTOM_DATA_KEY_IMAGE_UPLOAD = '_Image_Upload';

  customElements.define(
    ELEMENT_NAME,
    class ProductFormCustom extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector(SELECTOR_FORM);
        if (!this.form) return;
        
        const variantIdInput = this.form.querySelector(SELECTOR_ID_INPUT);
        if (variantIdInput) {
          variantIdInput.disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector(SELECTOR_CART_NOTIFICATION) || document.querySelector(SELECTOR_CART_DRAWER);
        this.submitButton = this.querySelector(SELECTOR_SUBMIT_BUTTON);
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector(SELECTOR_SPAN);
          if (document.querySelector(SELECTOR_CART_DRAWER)) {
            this.submitButton.setAttribute(ATTR_ARIA_HASPOPUP, 'dialog');
          }
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.customData = {};
      }

      connectedCallback() {
        // Listen for all form changes and dispatch change event
        if (this.form) {
          this.form.addEventListener('change', () => {
            this.dispatchChangeEvent(CHANGE_TYPES.FORM);
          });
        }
        
        // Listen for color input changes and dispatch color change event
        $(this).on('change', SELECTOR_COLOR_INPUT, (e, eventData) => {
          const colorValue = $(e.target).attr(ATTR_DATA_VALUE);
          if (colorValue) {
            const source = eventData?.source || null;
            document.dispatchEvent(new CustomEvent(ProductFormCustom.EVENTS.COLOR_CHANGE, {
              bubbles: true,
              detail: { colorValue, source }
            }));
            this.dispatchChangeEvent(CHANGE_TYPES.COLOR);
          }
        });
        
        // Listen for size input changes and dispatch size change event
        $(this).on('change', SELECTOR_SIZE_INPUT, (e) => {
          const sizeValue = $(e.target).attr(ATTR_DATA_VALUE);
          if (sizeValue) {
            document.dispatchEvent(new CustomEvent(ProductFormCustom.EVENTS.SIZE_CHANGE, {
              bubbles: true,
              detail: { sizeValue }
            }));
            this.dispatchChangeEvent(CHANGE_TYPES.SIZE);
          }
        });
      }

      // ============================================================================
      // Dispatch Change Event
      // ============================================================================
      dispatchChangeEvent(changeType = CHANGE_TYPES.UNKNOWN) {
        if (!this.form) return;
        
        const formData = new FormData(this.form);
        const data = {};
        
        // Get all form fields
        for (const [key, value] of formData.entries()) {
          if (data[key]) {
            if (Array.isArray(data[key])) {
              data[key].push(value);
            } else {
              data[key] = [data[key], value];
            }
          } else {
            data[key] = value;
          }
        }
        
        // Get variant ID
        const variantId = this.variantIdInput ? this.variantIdInput.value : null;
        
        // Get current color and size
        const currentColor = this.getCurrentColor();
        const currentSize = this.getCurrentSize();
        
        // Dispatch event
        document.dispatchEvent(new CustomEvent(ProductFormCustom.EVENTS.CHANGE, {
          bubbles: true,
          detail: {
            changeType: changeType,
            formId: this.form.id || null,
            variantId: variantId,
            currentColor: currentColor,
            currentSize: currentSize,
            formData: data,
            customData: { ...this.customData },
            timestamp: new Date().toISOString()
          }
        }));
      }

      // ============================================================================
      // Events
      // ============================================================================
      static get EVENTS() {
        return {
          CHANGE: EVENT_CHANGE,
          COLOR_CHANGE: EVENT_COLOR_CHANGE,
          SIZE_CHANGE: EVENT_SIZE_CHANGE
        };
      }

      // ============================================================================
      // Custom Data Keys
      // ============================================================================
      static get CUSTOM_DATA_KEYS() {
        return {
          MOCKUP: CUSTOM_DATA_KEY_MOCKUP,
          IMAGE_UPLOAD: CUSTOM_DATA_KEY_IMAGE_UPLOAD
        };
      }

      // ============================================================================
      // Custom Data Management
      // ============================================================================
      setCustomData(key, value) {
        if (typeof key !== 'string') return false;
        this.customData[key] = value;
        this.dispatchChangeEvent(CHANGE_TYPES.CUSTOM_DATA);
        return true;
      }

      getCustomData(key) {
        if (typeof key !== 'string') return null;
        return this.customData[key] || null;
      }

      clearCustomData(key) {
        if (key) {
          if (typeof key === 'string' && this.customData.hasOwnProperty(key)) {
            delete this.customData[key];
            this.dispatchChangeEvent(CHANGE_TYPES.CUSTOM_DATA);
            return true;
          }
          return false;
        }
        this.customData = {};
        this.dispatchChangeEvent(CHANGE_TYPES.CUSTOM_DATA);
        return true;
      }

      // Convenience methods for image data
      setMockup(dataUrl) {
        const result = this.setCustomData(ProductFormCustom.CUSTOM_DATA_KEYS.MOCKUP, dataUrl);
        if (result) {
          this.dispatchChangeEvent(CHANGE_TYPES.MOCKUP_SET);
        }
        return result;
      }

      setOriginalImage(imageUrl) {
        const result = this.setCustomData(ProductFormCustom.CUSTOM_DATA_KEYS.IMAGE_UPLOAD, imageUrl);
        if (result) {
          this.dispatchChangeEvent(CHANGE_TYPES.ORIGINAL_IMAGE_SET);
        }
        return result;
      }

      getMockup() {
        return this.getCustomData(ProductFormCustom.CUSTOM_DATA_KEYS.MOCKUP);
      }

      getOriginalImage() {
        return this.getCustomData(ProductFormCustom.CUSTOM_DATA_KEYS.IMAGE_UPLOAD);
      }

      clearMockup() {
        return this.clearCustomData(ProductFormCustom.CUSTOM_DATA_KEYS.MOCKUP);
      }

      clearOriginalImage() {
        return this.clearCustomData(ProductFormCustom.CUSTOM_DATA_KEYS.IMAGE_UPLOAD);
      }

      clearImageData() {
        this.clearMockup();
        this.clearOriginalImage();
        this.dispatchChangeEvent(CHANGE_TYPES.CUSTOM_DATA);
        return true;
      }

      // ============================================================================
      // Form Submission
      // ============================================================================
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton || this.submitButton.getAttribute(ATTR_ARIA_DISABLED) === 'true') return;



        this.submitButton.setAttribute(ATTR_ARIA_DISABLED, true);
        this.submitButton.classList.add(CLASS_LOADING);
        this.querySelector(SELECTOR_LOADING_SPINNER).classList.remove(CLASS_HIDDEN);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // Helper function to convert data URL to blob
        const dataURLtoBlob = (dataURI, type = 'image/png') => {
          if (!dataURI || typeof dataURI !== 'string' || !dataURI.includes(',')) {
            return null;
          }
          try {
            const byteString = atob(dataURI.split(',')[1]);
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }
            // Detect MIME type from data URL if available
            const mimeMatch = dataURI.match(/data:([^;]+)/);
            const mimeType = mimeMatch ? mimeMatch[1] : type;
            return new Blob([ab], { type: mimeType });
          } catch (e) {
            console.error('Error converting data URL to blob:', e);
            return null;
          }
        };
        
        // Add custom data to FormData as properties
        Object.keys(this.customData).forEach(key => {
          const value = this.customData[key];
          if (value !== null && value !== undefined) {
            // Convert _Mockup data URL to blob
            if (key === CUSTOM_DATA_KEY_MOCKUP && typeof value === 'string' && value.startsWith('data:')) {
              const blob = dataURLtoBlob(value);
              if (blob) {
                formData.append(`properties[${key}]`, blob, 'mockup.png');
              } else {
                // Fallback to string if conversion fails
                formData.append(`properties[${key}]`, String(value));
              }
            } else {
              formData.append(`properties[${key}]`, String(value));
            }
          }
        });

        if (this.cart) {
          const sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id);
          // Include cart-icon-bubble for cart notification
          sectionsToRender.push('cart-icon-bubble');
          formData.append('sections', [...new Set(sectionsToRender)].join(','));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        } else {
          // If no cart element, still request cart-icon-bubble for cart notification
          formData.append('sections', 'cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.error = true;
              return;
            }
            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.addedToCart, {
                source: 'product-form-custom',
                productVariantId: formData.get('id'),
                cartData: response,
              }).catch((err) => {
                console.error('[ProductForm] Error publishing addedToCart event:', err);
              });
              publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form-custom',
                  productVariantId: formData.get('id'),
                  cartData: response,
                }).then(() => {
                    CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);

                }).catch((err) => {
                  console.error('[ProductForm] Error publishing cartUpdate event:', err);
                }); 
              }
            }

            this.error = false;
  
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove(CLASS_LOADING);
            if (this.cart && this.cart.classList.contains(CLASS_IS_EMPTY)) {
              this.cart.classList.remove(CLASS_IS_EMPTY);
            }
            if (!this.error) {
              this.submitButton.removeAttribute(ATTR_ARIA_DISABLED);
            }
            this.querySelector(SELECTOR_LOADING_SPINNER).classList.add(CLASS_HIDDEN);
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

   
      // ============================================================================
      // Submit Button Management
      // ============================================================================
      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton || !this.submitButtonText) return;
        
        if (disable) {
          this.submitButton.setAttribute(ATTR_DISABLED, ATTR_DISABLED);
          if (text) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute(ATTR_DISABLED);
          this.updateSubmitButtonText();
        }
      }

      updateSubmitButtonText() {
        if (!this.submitButton || !this.submitButtonText) return;

        const price = this.submitButton.getAttribute(ATTR_DATA_PRICE);
        const showPriceInButton = this.submitButton.getAttribute(ATTR_DATA_SHOW_PRICE_IN_BUTTON) === 'true';
        
        if (price && showPriceInButton) {
          const isAutoDiscount = this.submitButton.getAttribute(ATTR_DATA_AUTO_DISCOUNT) === 'true';
          const originalPrice = this.submitButton.getAttribute(ATTR_DATA_ORIGINAL_PRICE);
          
          if (isAutoDiscount && originalPrice && window.autoDiscount?.enabled) {
            const formattedPrice = this.formatPrice(price);
            this.submitButtonText.innerHTML = `${window.variantStrings.addToCart} <span class="${CLASS_BUTTON_PRICE}">${formattedPrice}</span>`;
          } else {
            const formattedPrice = this.formatPrice(price);
            this.submitButtonText.innerHTML = `${window.variantStrings.addToCart} <span class="${CLASS_BUTTON_PRICE}">${formattedPrice}</span>`;
          }
        } else {
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      formatPrice(price) {
        const priceInDollars = price / 100;
        if (priceInDollars % 1 === 0) {
          return `$${priceInDollars}`;
        }
        return priceInDollars.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        });
      }

      // ============================================================================
      // Form Controls
      // ============================================================================
      get variantIdInput() {
        return this.form.querySelector(SELECTOR_ID_INPUT);
      }

      getButtons() {
        const $root = $(this);
        if (!$root.length) return $();
        return $root.find(SELECTOR_FORM_BTN);
      }

      getSubmitButton() {
        const $root = $(this);
        if (!$root.length) return $();
        return $root.find(SELECTOR_FORM_BTN_SUBMIT);
      }

      getVariantElements() {
        const $root = $(this);
        return {
          labels: $root.find(SELECTOR_VARIANT_LABEL),
          inputs: $root.find(SELECTOR_VPC_CARD_INPUT)
        };
      }

      disableButton() {
        const $buttons = this.getButtons();
        const { labels, inputs } = this.getVariantElements();
        
        let hasChanges = false;
        if ($buttons.length) {
          $buttons.prop('disabled', true);
          hasChanges = true;
        }
        if (labels.length) {
          labels.css('pointer-events', 'none').addClass(CLASS_DISABLED);
          hasChanges = true;
        }
        if (inputs.length) {
          inputs.prop(ATTR_DISABLED, true);
          hasChanges = true;
        }
        return hasChanges;
      }

      enableButton() {
        const $buttons = this.getButtons();
        const { labels, inputs } = this.getVariantElements();
        
        let hasChanges = false;
        if ($buttons.length) {
          $buttons.prop(ATTR_DISABLED, false);
          hasChanges = true;
        }
        if (labels.length) {
          labels.css('pointer-events', '').removeClass(CLASS_DISABLED);
          hasChanges = true;
        }
        if (inputs.length) {
          inputs.prop(ATTR_DISABLED, false);
          hasChanges = true;
        }
        return hasChanges;
      }

      clearForm() {
        if (!this.form) return false;
        this.form.reset();
        // Dispatch change event after form reset to notify listeners
        this.dispatchChangeEvent(CHANGE_TYPES.FORM);
        return true;
      }

      clearCroppingNotes() {
        if (!this.form) return false;
        const croppingNotesFields = this.form.querySelectorAll('textarea[data-cropping-notes]');
        if (croppingNotesFields.length > 0) {
          croppingNotesFields.forEach(field => {
            field.value = '';
          });
          this.dispatchChangeEvent(CHANGE_TYPES.CUSTOM_DATA);
          return true;
        }
        return false;
      }

      // ============================================================================
      // Color & Size Methods
      // ============================================================================
      getCurrentColor() {
        const $root = $(this);
        
        // Try data-value-type first (for size options in variant-picker-custom)
        let $colorInput = $root.find(`${SELECTOR_COLOR_INPUT}:checked`);
        if ($colorInput.length) {
          return $colorInput.attr(ATTR_DATA_VALUE) || null;
        }
        
        // Fallback: find by name pattern options[Color] (case-insensitive)
        const $allInputs = $root.find('input[type="radio"]');
        $colorInput = $allInputs.filter((i, el) => {
          const name = $(el).attr('name') || '';
          return /^options\[color\]$/i.test(name) && $(el).is(':checked');
        });
        
        if ($colorInput.length) {
          // Normalize the value (lowercase)
          const value = $colorInput.val();
          return value ? value.toLowerCase().trim() : null;
        }
        
        return null;
      }

      getCurrentSize() {
        const $root = $(this);
        
        // Try data-value-type first (for size options in variant-picker-custom)
        let $sizeInput = $root.find(`${SELECTOR_SIZE_INPUT}:checked`);
        if ($sizeInput.length) {
          return $sizeInput.attr(ATTR_DATA_VALUE) || null;
        }
        
        // Fallback: find by name pattern options[Size] (case-insensitive)
        const $allInputs = $root.find('input[type="radio"]');
        $sizeInput = $allInputs.filter((i, el) => {
          const name = $(el).attr('name') || '';
          return /^options\[size\]$/i.test(name) && $(el).is(':checked');
        });
        
        if ($sizeInput.length) {
          // Normalize the value (lowercase)
          const value = $sizeInput.val();
          return value ? value.toLowerCase().trim() : null;
        }
        
        return null;
      }

      getAvailableOptions(optionType) {
        const $root = $(this);
        const $inputs = $root.find(`[${ATTR_DATA_VALUE_TYPE}="${optionType}"]`);
        const values = [];
        
        $inputs.each(function() {
          const value = $(this).attr(ATTR_DATA_VALUE);
          if (value && !values.includes(value)) {
            values.push(value);
          }
        });
        
        return values;
      }

      // ============================================================================
      // Product Information Methods
      // ============================================================================
      getProductTitle() {
        if (!this.form) return '';

        // Get from JSON data (data-product-info script tag)
        try {
          const productDataScript = document.querySelector('script[data-product-info]');
          if (productDataScript) {
            const productData = JSON.parse(productDataScript.textContent);
            if (productData?.product?.title) {
              return productData.product.title;
            }
          }
        } catch (e) {
          // Ignore parse errors
        }

        return '';
      }

      getCurrentVariantId() {
        if (!this.form) return null;
        return this.variantIdInput?.value || null;
      }

      getCurrentSku() {
        if (!this.form) return '';

        // Get from JSON data (data-product-info script tag)
        try {
          const productDataScript = document.querySelector('script[data-product-info]');
          if (productDataScript) {
            const productData = JSON.parse(productDataScript.textContent);
            const variantId = this.getCurrentVariantId();
            if (variantId && productData?.variants && Array.isArray(productData.variants)) {
              const variant = productData.variants.find(v => String(v.id) === String(variantId));
              if (variant?.sku) {
                return variant.sku;
              }
            }
          }
        } catch (e) {
          // Ignore parse errors
        }

        return '';
      }

      getCurrentTemplate() {
        if (!this.form) return '';

        // Get from hidden input field properties[_template]
        const templateInput = this.form.querySelector('input[name="properties[_template]"]');
        if (templateInput?.value) {
          return templateInput.value;
        }

        return '';
      }

      updateColor(colorValue, options = {}) {
        if (!colorValue || typeof colorValue !== 'string') return false;
        
        const $root = $(this);
        const $colorInput = $root.find(`${SELECTOR_COLOR_INPUT}[${ATTR_DATA_VALUE}="${colorValue}"]`);
        
        if (!$colorInput.length) return false;
        
        // Update radio input
        $colorInput.prop('checked', true);
        
        // Update label classes - remove active from all, add to selected
        $(SELECTOR_COLOR_LABEL).removeClass(CLASS_SWATCH_ACTIVE);
        $(`${SELECTOR_COLOR_LABEL}[${ATTR_DATA_COLOR_VALUE}="${colorValue}"]`).addClass(CLASS_SWATCH_ACTIVE);
        
        // Trigger change event to update variant picker (variant ID, price, labels)
        // The change event listener will dispatch color:change event
        // Pass source info if provided
        $colorInput.trigger('change', options.source ? [{ source: options.source }] : []);
        
        // Also dispatch native change event on variant-selects to ensure it bubbles properly
        // jQuery trigger() creates synthetic events that don't bubble like native events
        const variantSelects = $root.find(SELECTOR_VARIANT_SELECTS)[0];
        if (variantSelects) {
          variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
        }
        
        return true;
      }

      getFormDataObject() {
        if (!this.form) return null;
        
        const formData = new FormData(this.form);
        
        // Add custom data to FormData as properties
        Object.keys(this.customData).forEach(key => {
          const value = this.customData[key];
          if (value != null) {
            formData.append(`properties[${key}]`, String(value));
          }
        });
        
        // Convert FormData to object, handling multiple values for same key
        const result = {};
        for (const [key, value] of formData.entries()) {
          if (key in result) {
            // Convert to array if multiple values exist
            result[key] = Array.isArray(result[key]) 
              ? [...result[key], value]
              : [result[key], value];
          } else {
            result[key] = value;
          }
        }
        
        return result;
      }
    }
  );

  // Static API
  window.ProductFormCustom = window.ProductFormCustom || {};
  
  // Expose EVENTS constant
  window.ProductFormCustom.EVENTS = ProductFormCustom.EVENTS;
  
  // Get product-form-custom instance by form ID (finds form by ID, returns parent product-form-custom)
  const getInstanceById = (formId) => {
    if (!formId) return null;
    const formElement = document.getElementById(formId);
    return formElement?.closest(ELEMENT_NAME) || null;
  };
  
  // Get instance by form ID
  window.ProductFormCustom.id = getInstanceById;
  
  // Get all instances on page as object { formId: instance }
  window.ProductFormCustom.getAll = () => {
    const instances = {};
    document.querySelectorAll(ELEMENT_NAME).forEach(element => {
      const form = element.querySelector(SELECTOR_FORM);
      if (form && form.id) {
        instances[form.id] = element;
      }
    });
    return instances;
  };
  
  // Static methods with form ID parameter
  window.ProductFormCustom.enableButton = (formId) => {
    const instance = getInstanceById(formId);
    return instance?.enableButton?.() || false;
  };
  
  window.ProductFormCustom.disableButton = (formId) => {
    const instance = getInstanceById(formId);
    return instance?.disableButton?.() || false;
  };
  
  window.ProductFormCustom.clearForm = (formId) => {
    const instance = getInstanceById(formId);
    return instance?.clearForm?.() || false;
  };
  
  window.ProductFormCustom.clearCroppingNotes = (formId) => {
    const instance = getInstanceById(formId);
    return instance?.clearCroppingNotes?.() || false;
  };
  
  window.ProductFormCustom.setMockup = (formId, dataUrl) => {
    const instance = getInstanceById(formId);
    return instance?.setMockup?.(dataUrl) || false;
  };
  
  window.ProductFormCustom.setOriginalImage = (formId, imageUrl) => {
    const instance = getInstanceById(formId);
    return instance?.setOriginalImage?.(imageUrl) || false;
  };
  
  window.ProductFormCustom.getMockup = (formId) => {
    const instance = getInstanceById(formId);
    return instance?.getMockup?.() || null;
  };
  
  window.ProductFormCustom.getOriginalImage = (formId) => {
    const instance = getInstanceById(formId);
    return instance?.getOriginalImage?.() || null;
  };
  
  window.ProductFormCustom.clearImageData = (formId) => {
    const instance = getInstanceById(formId);
    return instance?.clearImageData?.() || false;
  };
  
  window.ProductFormCustom.setCustomData = (formId, key, value) => {
    const instance = getInstanceById(formId);
    return instance?.setCustomData?.(key, value) || false;
  };
  
  window.ProductFormCustom.getCustomData = (formId, key) => {
    const instance = getInstanceById(formId);
    return instance?.getCustomData?.(key) || null;
  };
  
  window.ProductFormCustom.clearCustomData = (formId, key) => {
    const instance = getInstanceById(formId);
    return instance?.clearCustomData?.(key) || false;
  };
  
  window.ProductFormCustom.getFormDataObject = (formId) => {
    const instance = getInstanceById(formId);
    return instance?.getFormDataObject?.() || {};
  };
  
  window.ProductFormCustom.updateColor = (formId, colorValue, options = {}) => {
    const instance = getInstanceById(formId);
    return instance?.updateColor?.(colorValue, options) || false;
  };
  
  window.ProductFormCustom.getCurrentColor = (formId) => {
    const instance = getInstanceById(formId);
    return instance?.getCurrentColor?.() || null;
  };
  
  window.ProductFormCustom.getCurrentSize = (formId) => {
    const instance = getInstanceById(formId);
    return instance?.getCurrentSize?.() || null;
  };

  window.ProductFormCustom.getCurrentVariantId = (formId) => {
    const instance = getInstanceById(formId);
    return instance?.getCurrentVariantId?.() || null;
  };

  window.ProductFormCustom.getAvailableOptions = (formId, optionType) => {
    const instance = getInstanceById(formId);
    return instance?.getAvailableOptions?.(optionType) || [];
  };

  window.ProductFormCustom.getProductTitle = (formId) => {
    const instance = getInstanceById(formId);
    return instance?.getProductTitle?.() || '';
  };

  window.ProductFormCustom.getCurrentSku = (formId) => {
    const instance = getInstanceById(formId);
    return instance?.getCurrentSku?.() || '';
  };

  window.ProductFormCustom.getCurrentTemplate = (formId) => {
    const instance = getInstanceById(formId);
    return instance?.getCurrentTemplate?.() || '';
  };
}
